var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLess(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.26562 4.66101L8.34375 7.47351C8.76562 7.61413 9.25781 7.4032 9.39844 7.00476L9.67969 6.30163C9.84375 5.92663 9.63281 5.48132 9.1875 5.3407L5.08594 3.74695L9.1875 2.1532C9.63281 2.01257 9.84375 1.5907 9.67969 1.19226L9.39844 0.489135C9.25781 0.114135 8.76562 -0.0968028 8.34375 0.0438222L1.26562 2.85632C0.960938 2.97351 0.75 3.25476 0.75 3.58288V3.95788C0.75 4.26257 0.960938 4.54382 1.26562 4.66101ZM9.9375 8.99695H0.5625C0.234375 8.99695 0 9.25476 0 9.55945V10.6844C0 11.0126 0.234375 11.2469 0.5625 11.2469H9.9375C10.2422 11.2469 10.5 11.0126 10.5 10.6844V9.55945C10.5 9.25476 10.2422 8.99695 9.9375 8.99695Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLess);
export default __webpack_public_path__ + "static/media/less.a028026e.svg";
export { ForwardRef as ReactComponent };